import React, { useState, useEffect } from "react";
import Loader from "./Loader";

// Branded loader shown ONCE on first app load, then never again.
// Route-to-route transitions are handled by RouteTransition (see App.js).
const PageLoader = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [fadeOut, setFadeOut] = useState(false);

	useEffect(() => {
		let removeId;
		const finish = () => {
			setFadeOut(true);
			removeId = setTimeout(() => setLoading(false), 500);
		};

		// If the document is already loaded, show a brief beat then fade.
		if (document.readyState === "complete") {
			const t = setTimeout(finish, 300);
			return () => clearTimeout(t);
		}

		window.addEventListener("load", finish);
		const safetyCap = setTimeout(finish, 1500); // never hang
		return () => {
			window.removeEventListener("load", finish);
			clearTimeout(safetyCap);
			clearTimeout(removeId);
		};
	}, []);

	return (
		<>
			{loading && (
				<div className={`loader-container ${fadeOut ? "hide" : ""}`}>
					<Loader />
				</div>
			)}
			{children}
		</>
	);
};

export default PageLoader;
